import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

import { useProductCard } from './context';

type ProductCardFrontProps = ComponentProps<'div'>;

/**
 * The offer itself. Stays in normal flow, so it is what gives the card its height by default.
 *
 * Hidden to assistive technology and taken out of the tab order once the what's-included panel is
 * over it: the panel covers it completely but does not replace it, so without this the front's
 * buttons are still tabbable underneath — a keyboard user reading the panel would tab from it into
 * controls they cannot see. The mirror of what the panel does while it is the hidden one.
 */
const ProductCardFront = ({ className, children, ...props }: ProductCardFrontProps) => {
  const { frontRef, showWhatsIncluded } = useProductCard();
  return (
    <div
      ref={frontRef}
      aria-hidden={showWhatsIncluded}
      inert={showWhatsIncluded}
      className={cn('flex w-full flex-col items-center', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </div>
  );
};

export default ProductCardFront;
